/**
 * Created by Yoyo Fang on 09/02/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ComponentRef, Type } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

import { WidgetListItem, WidgetInstance, WidgetInstanceListFeedback } from './widget-list.model';
import { UUID } from 'angular2-uuid';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';

@Component({
    selector: 'tam-widget-list',
    templateUrl: './widget-list.component.html',
    styleUrls: ['./widget-list.component.scss']
})
export class WidgetListComponent implements OnInit, OnDestroy {
    @ViewChild('dropdownlist', { static: false }) dropdownlist: DropDownListComponent;

    addingWidget: any = null;
    widgetList: WidgetListItem[] = [];
    filteredWidgetList: WidgetListItem[] = [];
    instanceList: WidgetInstance[] = [];
    instanceListSubject$: Subject<WidgetInstanceListFeedback>;
    loading = false;
    private _destroySubscriptions: Array<Subscription> = [];

    componentRef: ComponentRef<any>;
    constructor(
    ) {
    }

    ngOnInit() {
        this.instanceListSubject$ = new Subject<WidgetInstanceListFeedback>();
    }


    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    /**
     * create a dynimac component
     */
    createComponent<T>(widgetId: string, instance?: WidgetInstance, sendFeedback?: boolean): WidgetInstance {
        const widgetItem = this.widgetList.find((item) => item.id === widgetId);
        if (!widgetItem) {
            return null;
        }

        const existingCount = this.instanceList.reduce<number>((acc, cur) => {
            if (cur.widgetId === widgetItem.id) {
                return acc + 1;
            }
            return acc;
        }, 0);
        if (existingCount === widgetItem.maxCount) {
            return null;
        }

        widgetItem.maxCount--;
        this._reinitFilteredWidgetList();

        if (!instance) {
            instance = new WidgetInstance(
                UUID.UUID(),
                widgetItem.componentType,
                (inst: WidgetInstance) => {
                    widgetItem.componentInitializer(inst.componentReference, inst.value);
                });

            instance.widgetId = widgetItem.id;
            this.instanceListSubject$.next({ type: 'add', payload: instance });
        } else if (sendFeedback) {
            this.instanceListSubject$.next({ type: 'add', payload: instance });
        }
        this.instanceList.push(instance);
        return instance;
    }

    /**
     * delete a dynimac component
     */
    deleteComponent<T>(id: string): boolean {
        const existing = this.instanceList.find((cur) => cur.id === id);
        if (existing) {
            this.instanceList = this.instanceList.filter((item) => item.id !== id);
            this.instanceListSubject$.next({ type: 'delete', payload: existing });

            const widgetItem = this.widgetList.find((item) => item.id === existing.widgetId);
            widgetItem.maxCount++;
            this._reinitFilteredWidgetList();
            return true;
        }
        return false;
    }

    onItemDeleted(id) {
        this.deleteComponent(id);
    }

    init(widgetList: WidgetListItem[], instanceList?: WidgetInstance[]) {
        this.loading = true;
        this.instanceList.forEach(instance => {
            instance.componentReference.destroy();
        });
        this.instanceList = [];
        this.widgetList = widgetList;
        this._reinitFilteredWidgetList();
        if (instanceList && instanceList.length > 0) {
            instanceList.forEach(instance => {
                this.createComponent(instance.widgetId, instance);
            });
        }
        this.loading = false;
    }

    onItemClick(event) {
        this.createComponent(event.id);
        this.dropdownlist.reset();
    }

    reset() {
        this._unselectDropdownList();
        this.widgetList = [];
        this.filteredWidgetList = [];
        this.instanceList = [];
        this.loading = false;
    }

    refreshItem(item: WidgetInstance) {
        this.instanceListSubject$.next({ type: 'refreshItem', payload: item });
    }

    handleFilter(value) {
        this.filteredWidgetList = this.widgetList.filter((s) => s.maxCount !== 0 && s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    private _unselectDropdownList() {
        if (this.dropdownlist) {
            this.dropdownlist.reset();
        }
    }

    private _reinitFilteredWidgetList() {
        this.filteredWidgetList = this.widgetList.filter((s) => s.maxCount !== 0);
        this._unselectDropdownList();
    }
}

